/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateAccount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CreateAccount({
  children,
  viewPath = "/App/Auth/SignUp/CreateAccount",
  isSubmitting,
  onSubmit
  
}) {
let signupSubmitData = fromData.useDataSubmit({ viewPath,
context: 'signup',
})
let signupIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'signup',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 size="large"
 block={true}
 data="signup"
 disabled={signupIsSubmittingData}
 onClick={signupSubmitData}
 marginTop={dtSpaceL}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send Instructions"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}